import $ from 'jquery';

$(() => {
  $('[data-max-size]').on('input', (event) => {
    const $target = $(event.currentTarget);
    const currentSize = $target.val().length;
    const maxSize = $target.data('maxSize');
    const remainingCharacters = maxSize - currentSize;
    const $formGroup = $target.closest('.form-group');
    if (remainingCharacters >= 0) {
      $formGroup.removeClass('has-error');
    } else {
      $formGroup.addClass('has-error');
    }
  });
});
